import { Box, Button, IconButton, Typography } from '@mui/material';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { FONT_SERIF, WD } from '../../../warningDashboard/warningTheme';
import { HOVER_BG, WEEKDAYS } from '../utils/constants';
import { formatMonth, startOfMonth } from '../utils/dates';
import Panel from './Panel';
import CalendarDayCell from './CalendarDayCell';

/**
 * The month at a glance: the team's hours against its capacity, day by day. The tags count people over 100% and people under 50%
 * that day; hovering one lists them.
 */
export default function MonthCalendar({ anchor, daily, today, selected, onSelect, onPrev, onNext, onToday }) {
  const month = startOfMonth(anchor).slice(0, 7);

  return (
    <Panel sx={{ overflow: 'hidden' }}>
      <Box display="flex" flexWrap="wrap" alignItems="center" justifyContent="space-between" gap={1.5} sx={{ px: 2.5, py: 2 }}>
        <Box display="flex" alignItems="center" gap={0.5}>
          <IconButton size="small" aria-label="Previous month" onClick={onPrev}><ChevronLeftRoundedIcon /></IconButton>
          <Typography component="h2" sx={{ minWidth: 150, textAlign: 'center', fontFamily: FONT_SERIF, fontSize: 18, fontWeight: 600, color: WD.ink }}>
            {formatMonth(anchor)}
          </Typography>
          <IconButton size="small" aria-label="Next month" onClick={onNext}><ChevronRightRoundedIcon /></IconButton>
          <Button size="small" variant="outlined" onClick={onToday} sx={{ ml: 1 }}>Today</Button>
        </Box>
        <Typography sx={{ fontSize: 12, color: WD.inkMuted }}>Team utilisation per day · click a day to open it</Typography>
      </Box>

      <Box display="grid" gridTemplateColumns="repeat(7, minmax(0, 1fr))" sx={{ borderTop: `1px solid ${WD.border}`, borderBottom: `1px solid ${WD.border}`, bgcolor: HOVER_BG }}>
        {WEEKDAYS.map((name) => (
          <Typography key={name} sx={{ px: { xs: 0.75, sm: 1.5 }, py: 1, fontSize: 11, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: WD.inkMuted }}>
            {name}
          </Typography>
        ))}
      </Box>

      <Box display="grid" gridTemplateColumns="repeat(7, minmax(0, 1fr))">
        {daily.map((cell, index) => (
          <CalendarDayCell
            key={cell.day}
            cell={cell}
            inMonth={cell.day.startsWith(month)}
            isToday={cell.day === today}
            isSelected={cell.day === selected}
            lastColumn={index % 7 === 6}
            lastRow={index >= daily.length - 7}
            onSelect={onSelect}
          />
        ))}
      </Box>
    </Panel>
  );
}
